var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "-394 635.7 200 200",
    style: {
      enableBackground: "new -394 635.7 200 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M-217,835.7h-154c-12.7,0-23-10.3-23-23v-154c0-12.7,10.3-23,23-23h154c12.7,0,23,10.3,23,23v154 C-194,825.4-204.3,835.7-217,835.7z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-293.7,683c3.3,0,14-2.1,22.3-14.2c7.1-10.5,6.3-22.2,6.3-22.2s-12.3-0.9-23.1,12.5 c-7.8,9.8-7.2,23.8-7.2,23.8S-294.8,683-293.7,683z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-232,759.9c0.6-1.7,1-2.7,1-2.7s0,0-0.1,0l0,0c0,0-0.1,0-0.2-0.1l0,0c-0.6-0.2-2-0.8-3.8-1.9l0,0 c-3.6-2.1-8.6-6-12.2-12.3l0,0c-2.3-4-3.9-9-4.3-15.2c-0.2-3.1,0.1-6.1,0.7-8.8v-0.1c0.2-0.9,0.4-1.7,0.7-2.6l0,0 c3.2-10.4,10.7-17.2,13.7-19.5l0,0c0.8-0.6,1.2-0.9,1.2-0.9s-9.6-14.9-27.7-14.9c-15.6,0-21.4,7-29.7,7 c-10.2,0-11.8-6.5-26.9-6.5c-7.8,0-18.7,3-26.8,13.5c-6.4,8.2-8.8,17.9-9.8,25l0,0c-0.6,4.8-0.8,10-0.2,15.8l0,0 c0,0.4,0.1,0.8,0.1,1.3c0.6,5.8,2.1,12,4.2,18.2l0,0c0,0.1,0.1,0.3,0.2,0.4c0.2,0.7,0.5,1.5,0.8,2.2c0.1,0.3,0.3,0.7,0.4,1 c0.1,0.3,0.2,0.7,0.4,1l0,0c2,5.2,4.3,10.2,7,14.9l0,0c7.8,13.8,17.9,24.2,27.4,24.2c10.8,0,14.2-7,25-6.9 c13.7,0.1,17.5,8.8,29,6.5c7.7-1.5,16.9-12.4,22.8-22.8c0.2-0.4,0.4-0.7,0.6-1l0,0C-235.7,768.7-233.3,763.1-232,759.9 L-232,759.9z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.c915880e7ea4975373fca8d45c63b75b.svg";
export { ForwardRef as ReactComponent };